import { render, staticRenderFns } from "./LazyRenderer.vue?vue&type=template&id=e79d80f8&lang=pug&"
import script from "./LazyRenderer.vue?vue&type=script&lang=js&"
export * from "./LazyRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports